import {
  ApartmentOutlined,
  AppstoreOutlined,
  BookOutlined,
  ContainerOutlined,
  ExperimentOutlined,
  InboxOutlined,
  ToolOutlined,
  UserSwitchOutlined,
  AuditOutlined,
  BankOutlined,
  CoffeeOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  DollarOutlined,
  FileDoneOutlined,
  FileProtectOutlined,
  HomeOutlined,
  IdcardOutlined,
  LockOutlined,
  MessageOutlined,
  NotificationOutlined,
  PercentageOutlined,
  ReadOutlined,
  SafetyCertificateOutlined,
  SafetyOutlined,
  ScheduleOutlined,
  ShoppingOutlined,
  SolutionOutlined,
  SwapOutlined,
  SyncOutlined,
  TeamOutlined,
  ThunderboltOutlined,
  UsergroupAddOutlined,
  WalletOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { registerAdminNavItem } from '../../layout/admin/navigation';

/**
 * Admin sidebar structure. Each module owns its own registration so the
 * central list stays open to extension (NN-16). Icons come from Ant Design
 * so we get one consistent stroke weight across the whole rail.
 */

// Home
registerAdminNavItem({ key: 'briefing', label: 'Briefing', path: '', group: 'home', order: 10, icon: <HomeOutlined /> });
registerAdminNavItem({ key: 'inbox', label: 'Action queue', path: 'inbox', group: 'home', order: 20, icon: <ThunderboltOutlined /> });

// Admissions
registerAdminNavItem({ key: 'inquiries', label: 'Inquiries', path: 'admissions/inquiries', group: 'admissions', order: 10, icon: <MessageOutlined /> });
registerAdminNavItem({ key: 'applications', label: 'Applications', path: 'admissions/applications', group: 'admissions', order: 20, icon: <SolutionOutlined /> });
registerAdminNavItem({ key: 'merit', label: 'Merit list', path: 'admissions/merit', group: 'admissions', order: 30, icon: <FileDoneOutlined /> });
registerAdminNavItem({ key: 'allocation', label: 'Allocation', path: 'admissions/allocation', group: 'admissions', order: 40, icon: <PercentageOutlined /> });
registerAdminNavItem({ key: 'admissionSettings', label: 'Admission form', path: 'admissions/settings', group: 'admissions', order: 50, icon: <SafetyOutlined /> });

// People
registerAdminNavItem({ key: 'students', label: 'Students', path: 'students', group: 'people', order: 10, icon: <TeamOutlined /> });
registerAdminNavItem({ key: 'guardians', label: 'Guardians', path: 'guardians', group: 'people', order: 20, icon: <UsergroupAddOutlined /> });
registerAdminNavItem({ key: 'staff', label: 'Staff', path: 'staff', group: 'people', order: 30, icon: <IdcardOutlined /> });

// Academics
registerAdminNavItem({ key: 'attendance', label: 'Attendance', path: 'attendance', group: 'academics', order: 10, icon: <CheckCircleOutlined /> });
registerAdminNavItem({ key: 'timetable', label: 'Timetable', path: 'timetable', group: 'academics', order: 20, icon: <ScheduleOutlined /> });
registerAdminNavItem({ key: 'substitutions', label: 'Substitutions', path: 'timetable/substitutions', group: 'academics', order: 30, icon: <SwapOutlined /> });
registerAdminNavItem({ key: 'exams', label: 'Exams', path: 'exams', group: 'academics', order: 40, icon: <FileDoneOutlined /> });
registerAdminNavItem({ key: 'homework', label: 'Homework', path: 'homework', group: 'academics', order: 45, icon: <ReadOutlined /> });
registerAdminNavItem({ key: 'calendar', label: 'Calendar', path: 'structure/calendar', group: 'academics', order: 50, icon: <CalendarOutlined /> });

// Finance
registerAdminNavItem({ key: 'collections', label: 'Collections', path: 'fees/collections', group: 'finance', order: 10, icon: <WalletOutlined /> });
registerAdminNavItem({ key: 'defaulters', label: 'Defaulters', path: 'fees/defaulters', group: 'finance', order: 20, icon: <WarningOutlined /> });
registerAdminNavItem({ key: 'fee-structures', label: 'Fee structures', path: 'fees/structures', group: 'finance', order: 30, icon: <BankOutlined /> });
registerAdminNavItem({ key: 'concessions', label: 'Concessions', path: 'fees/concessions', group: 'finance', order: 35, icon: <PercentageOutlined /> });
registerAdminNavItem({ key: 'expenses', label: 'Expenses & bills', path: 'expenses/requisitions', group: 'finance', order: 40, icon: <ShoppingOutlined /> });
registerAdminNavItem({ key: 'payroll', label: 'Payroll', path: 'hr/payroll', group: 'finance', order: 50, icon: <DollarOutlined /> });
registerAdminNavItem({ key: 'leave', label: 'Staff leave', path: 'hr/leave', group: 'finance', order: 55, icon: <CoffeeOutlined /> });
registerAdminNavItem({ key: 'hr-attendance', label: 'Staff attendance', path: 'hr/attendance', group: 'finance', order: 57, icon: <CheckCircleOutlined /> });
registerAdminNavItem({ key: 'recruitment', label: 'Recruitment', path: 'hr/recruitment', group: 'finance', order: 58, icon: <UserSwitchOutlined /> });
registerAdminNavItem({ key: 'assets', label: 'Assets register', path: 'assets', group: 'finance', order: 60, icon: <ToolOutlined /> });
registerAdminNavItem({ key: 'inventory', label: 'Inventory', path: 'inventory', group: 'finance', order: 65, icon: <InboxOutlined /> });
registerAdminNavItem({ key: 'transport-assign', label: 'Transport assignments', path: 'transport/assignments', group: 'finance', order: 70, icon: <ContainerOutlined /> });

// Records
registerAdminNavItem({ key: 'broadcasts', label: 'Broadcasts', path: 'comms/broadcasts', group: 'records', order: 10, icon: <NotificationOutlined /> });
registerAdminNavItem({ key: 'messages', label: 'Messages', path: 'comms/messages', group: 'records', order: 15, icon: <MessageOutlined /> });
registerAdminNavItem({ key: 'certificates', label: 'Transfer certs', path: 'certificates/tc', group: 'records', order: 20, icon: <FileProtectOutlined /> });
registerAdminNavItem({ key: 'bonafide', label: 'Bonafide certs', path: 'certificates/bonafide', group: 'records', order: 22, icon: <SafetyCertificateOutlined /> });
registerAdminNavItem({ key: 'consents', label: 'Consents', path: 'comms/consents', group: 'records', order: 16, icon: <FileProtectOutlined /> });
registerAdminNavItem({ key: 'cert-verify', label: 'Verify certificate', path: 'certificates/verify', group: 'records', order: 25, icon: <SafetyOutlined /> });
registerAdminNavItem({ key: 'audit', label: 'Audit log', path: 'settings/audit', group: 'records', order: 30, icon: <AuditOutlined /> });
registerAdminNavItem({ key: 'compliance', label: 'Compliance & exports', path: 'compliance', group: 'records', order: 40, icon: <SafetyOutlined /> });

// Settings
registerAdminNavItem({ key: 'structure', label: 'Grades & sections', path: 'structure/grades', group: 'settings', order: 5, icon: <ApartmentOutlined /> });
registerAdminNavItem({ key: 'years', label: 'Academic years', path: 'structure/years', group: 'settings', order: 6, icon: <CalendarOutlined /> });
registerAdminNavItem({ key: 'subjects', label: 'Subjects', path: 'structure/subjects', group: 'settings', order: 7, icon: <BookOutlined /> });
registerAdminNavItem({ key: 'programs', label: 'Programs', path: 'structure/programs', group: 'settings', order: 8, icon: <ExperimentOutlined /> });
registerAdminNavItem({ key: 'rooms', label: 'Rooms', path: 'structure/rooms', group: 'settings', order: 9, icon: <AppstoreOutlined /> });
registerAdminNavItem({ key: 'roles', label: 'Roles & access', path: 'settings/roles', group: 'settings', order: 10, icon: <LockOutlined /> });
registerAdminNavItem({ key: 'people', label: 'People', path: 'settings/people', group: 'settings', order: 12, icon: <UsergroupAddOutlined /> });
registerAdminNavItem({ key: 'custom-fields', label: 'Custom fields', path: 'settings/fields', group: 'settings', order: 15, icon: <FileDoneOutlined /> });
registerAdminNavItem({ key: 'rollover', label: 'Session rollover', path: 'promotions', group: 'settings', order: 20, icon: <SyncOutlined /> });
